/* eslint-disable padding-line-between-statements */
import React, { useState, useEffect, useContext, useMemo, useCallback } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { WizardContext } from '@xengage/gw-portals-wizard-react';
import { TooltipIcon, useModal } from '@jutro/components';
import { MLFormService, MLBundleService, MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { UserService } from 'gw-capability-gateway';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLUserTypeUtil, MLFormUtil, MLErrorMessageUtil } from 'ml-portals-util-js';
import appConfig from 'app-config';
import PATrackEvent from '../../components/TrackEvent/PATrackEvent';
import VerbalAuthorizationComponent from '../../components/VerbalAuthorizationComponent/VerbalAuthorizationComponent';
import RequiredSignaturesComponent from '../../components/RequiredSignaturesComponent/RequiredSignaturesComponent';
import AvailableDocumentsComponent from '../../components/AvailableDocumentsComponent/AvailableDocumentsComponent';
import { AccountService } from 'gw-capability-gateway-policy';

import ApplySignatureTypeToAllPopupMetadata from './ApplySignatureTypeToAllPopup.metadata.json5';

import metadata from './AgentSignatureOptionsPage.metadata.json5';
import messages from './AgentSignatureOptionsPage.messages';
import PUMBTrackEvent from '../../components/TrackEvent/PUMBTrackEvent';
import HOTrackEvent from '../../components/TrackEvent/HOTrackEvent';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import styles from './AgentSignatureOptionsPage.module.scss';
import DisclaimerComponent from '../../components/DisclaimerComponent/DisclaimerComponent';

const {
    MLFormNumberWildcards
} = appConfig;

const steps = {
    VERBAL_AUTH: 'verbal_auth',
    DISCLAIMER: 'disclaimer',
    REQUIRED_SIGNATURES: 'required_signatures',
    AVAILABLE_DOCUMENTS: 'available_documents'
};

const PAYMENT_MISMATCH_ERROR = 'Payment information must match your selected billing method';
const PAYMENT_ERROR = 'Error when trying to make payment';

const AgentSignatureOptionsPage = (props) => {
    const modalApi = useModal();
    const { wizardData: submissionVM, updateWizardData, goNext, history } = props;
    //DE255327 field level error message's
    const [showValidationErrors, setShowErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);

    const [scriptML, setScriptML] = useState();
    const [currentStep, setCurrentStep] = useState(null);
    const [eSignatureForms, setESignatureForms] = useState([]);
    const [requiredSignaturesForms, setRequiredSignaturesForms] = useState([]);
    const [availableDocumentsForms, setAvailableDocumentsForms] = useState([]);
    const [oecRadioSelection ,setoecRadioSelection] = useState(null);
    const [hasVerbalAuth, setHasVerbalAuth] = useState(false);
    

    const { refreshData } = useDataRefresh();
    const { authHeader } = useAuthentication();
    const { onValidate, isComponentValid } = useValidation('AgentSignatureOptionsPage');
    const { portalCode } = appConfig;
    const gafInfo = _.get(submissionVM, 'baseData.gafInfo_ML.value', {})

    const wizardContext = useContext(WizardContext);    

    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const [displayEmailWarning, setDisplayEmailWarning] = useState(false)

    const SIGNATURETYPE_TYPELIST_FULL = viewModelService.productMetadata.get('pc').types.getTypelist('SignatureType_ML');

    const bindData = submissionVM.bindData;
    const producerCode = submissionVM.producerCodeOfRecord_ML.value;
    const isGpa = true;
    const allForms = bindData.forms_ML;
    const uwIssues = submissionVM.uwIssues_ML.value;
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();
    const isUMB_NP = isModernProduct && isPersonalUmbrella;
    const quoteID = _.get(submissionVM, 'quoteID.value');
    const gpaMode = (portalCode === 'GPA');
    const { mercerOrganization } = appConfig;
    const { mercerGpcCode } = appConfig;


    const [isFileUploadDone, setIsFileUploadDone] = useState(false);
    const {
        showProgressDialog,
        showErrorModal,
        hideProgressDialog
    } = MLModalService();

    const {
        addWarningAlert,
        clearBlockAlerts,
        addErrorAlert,
    } = MLNotificationBlockUtil();

    const getPageHeader = () => {
        switch (currentStep) {
            case steps.VERBAL_AUTH: {
                return messages.verbalAuthorization;
            }
            case steps.DISCLAIMER: {
                return messages.disclaimer;
            }
            case steps.REQUIRED_SIGNATURES: {
                return messages.requiredSignatures;
            }
            case steps.AVAILABLE_DOCUMENTS: {
                return messages.documents;
            }
            default: {
                return undefined;
            }
        }
    };

    function between(str, start, end) {
        const startIndex = str.indexOf(start);
        if (startIndex === -1)
            return "";

        const endIndex = str.indexOf(end, startIndex + start.length);
        if (endIndex === -1)
            return "";

        return str.substring(startIndex + start.length, endIndex);
    }

    useEffect(() => {
        UserService.getCurrentUser(authHeader).then((user) => {
            if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                HOTrackEvent('Issuance Step Reached', false, submissionVM, user, { step: 'Signature Page'});
            }
            else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                PUMBTrackEvent('Issuance Step Reached', false, submissionVM, user, { step: 'Signature Page'});
            }
            else {
                PATrackEvent('Issuance Step Reached', false, submissionVM, user, { step: 'Signature Page'});
            }
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const isDisclaimerScriptAvailable = useCallback(async() => {
        if (gpaMode) {
            const scriptRequest = { quoteID: submissionVM.quoteID.value };
            showProgressDialog(platformMessages.loading ,null,null ,0);
            const agentScript = await LoadSaveService.getScript('disclaimers', scriptRequest, authHeader);
            hideProgressDialog();
            if(!_.isEmpty(agentScript)){
                setScriptML(agentScript);
                return true
            }
            return false
        }
        return false
    },[authHeader, gpaMode, hideProgressDialog, showProgressDialog, submissionVM.quoteID.value])

    const initializeDisclaimerStep = async () => {
        const hasDisclaimers = await isDisclaimerScriptAvailable();
        if(hasDisclaimers){
            setCurrentStep(steps.DISCLAIMER);
            return;
        }

        setCurrentStep(steps.REQUIRED_SIGNATURES);
    }

    useEffect(() => {
        const initiazeStep =() =>{
            if ((MLUserTypeUtil.isGcsOrMetGaUser(submissionVM) && submissionVM.bindData && submissionVM.bindData.forms_ML &&
            submissionVM.bindData.forms_ML.children.find((form) => {
                return !!form.verbalAuthorization_ML.value;
            }))) {
            setHasVerbalAuth(true)
            setCurrentStep(steps.VERBAL_AUTH);
            return 
        }
        initializeDisclaimerStep();
    }
    initiazeStep();
        
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        switch (currentStep) {
            case steps.AVAILABLE_DOCUMENTS: {
                LoadSaveService.getScript('requiredSignatures', { quoteID: submissionVM.quoteID.value }, authHeader)
                    .then((lines) => {
                        setScriptML(lines);
                    });
                break;
            }
            default: {
                break;
            }
        }
    }, [authHeader, currentStep, submissionVM.quoteID.value]);

    useEffect(() => {
        setTimeout(()=>{
            const element = document.getElementById("gpaPageHeader");
            if(element){
                element.focus();
            }
        }, 100)
  }, []);

    const verbalAuthForms = useMemo(() => {
        return allForms.filter((form) => {
            if (form.verbalAuthorization_ML) {
                return form.verbalAuthorization_ML.value === true;
            }
            return false;
        });
    }, [allForms]);

    const getESignatureForms = useCallback(() => {
        return allForms.filter((form) => {
            if(form.esigned_ML){
                return form.esigned_ML.value === true;
            }
            return false;
        });
    }, [allForms]);

    const getUncheckedAndESigFormsValues = useCallback(() => {
        const filteredForms = (allForms || []).filter((form) => {
            return form?.esigned_ML?.value === true && !(form?.verbalAuthorization_ML?.value === true && form?.isSigned?.value === true);
        });
        return filteredForms;
    }, [allForms]);

    const getAllVerbalAndESigForms = useCallback(() => {
        if (hasVerbalAuth) {
            return [...new Set(verbalAuthForms.concat(eSignatureForms))];
        }
        return eSignatureForms;
    }, [eSignatureForms, verbalAuthForms]);

    const signatureTypeList = SIGNATURETYPE_TYPELIST_FULL.codes
        .filter((sigType) => { return sigType.code !== 'verbal' && sigType.code !== 'signature_on_file'; });
    const appSignatureTypeList = SIGNATURETYPE_TYPELIST_FULL.codes
        .filter((sigType) => { return sigType.code !== 'verbal'; });

    const isUserRetentionAgent = _.get(producerCode, 'isDocRetention_ML', false);
    const isBundle = submissionVM.isBundle_ML.value;

    const [currentUser, setCurrentUser] = useState({});
    const [organization, setOrganization] = useState(undefined);

    const getCurrentUser = () => {
        if (isGpa) {
            UserService.getCurrentUser(authHeader).then((user) => {
                setCurrentUser(user);
                if (user?.primaryProducerCode_ML?.organization_ML) {
                    setOrganization(user.primaryProducerCode_ML.organization_ML);
                }
            });
        }
    };

    useEffect(() => {
        getCurrentUser();
        setESignatureForms(getESignatureForms());
        setRequiredSignaturesForms(getUncheckedAndESigFormsValues());
        setAvailableDocumentsForms(getAllVerbalAndESigForms());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const convertDateToUTC = (date) => {
        if (date) {
            return date.toLocaleString('en-US', { timeZone: 'UTC', month: 'numeric', day: 'numeric', year: '2-digit', hour: '2-digit', minute: '2-digit' });
        }
        return '';
    };

    const isSignatureOnFileAvailable = (form) => {
        return isGpa && (currentUser.isIA || currentUser.isPCS || currentUser.isMetGA)
            && (form.formNumber.value.startsWith(MLFormNumberWildcards.AUTO_APPLICATION_FORM)
                || form.formNumber.value.startsWith(MLFormNumberWildcards.HOME_APPLICATION_FORM)
                || form.formNumber.value.startsWith(MLFormNumberWildcards.UMBRELLA_APPLICATION_FORM));
    };

    const shouldShowSecondEmail = (form) => {
        return form.secondEmailRequired.value || shouldShowExcludedDriverEmail(form) || shouldShowSNIEmail(form) || !!form?.secondaryInsuredEmailRequired?.value;
    };

    const shouldShowExcludedDriverEmail = (form) => {
        if (!_.isUndefined(form?.esignatureOptions?.value?.code) && form?.esignatureOptions?.value?.code === 'Text' && !_.isUndefined(form?.excludedDriverEmailRequired?.value) && form?.excludedDriverEmailRequired?.value) {
            return true;
        }
        return false;
    };

    const shouldShowSNIEmail = (form) => {
            if (!_.isUndefined(form?.esignatureOptions?.value?.code) && form?.esignatureOptions?.value?.code === 'Email' && !_.isUndefined(form?.secondEmailRequired?.value) && !form?.secondEmailRequired?.value && !_.isUndefined(form?.secondaryInsuredEmailRequired?.value) && form?.secondaryInsuredEmailRequired?.value) {
                return true;
            }
            return false;
        };

    const shouldShowSecondMobile = (form) => {
        return form?.secondaryMobileNumberRequired?.value || shouldShowExcludedMobile(form);
    }

    const shouldShowExcludedMobile = (form) => {
        if (!_.isUndefined(form?.esignatureOptions?.value?.code) && form?.esignatureOptions?.value?.code === 'Text' && !_.isUndefined(form?.excludedDriverMobileNumberRequired?.value) && form?.excludedDriverMobileNumberRequired?.value) {
            return true;
        }
        return false;
    };

    const shouldShowAdditionalInsuredEmail = (form) => {
        if (!_.isUndefined(form.additionalInsuredEmailRequired) && form.additionalInsuredEmailRequired.value && shouldShowSecondEmail) {
            return true;
        }
        return false;
    };

    const checkIfEmailsAreDuplicated = (form) => {
        if (shouldShowSecondEmail(form)) {
            if (form.namedInsuredEmail && form.secondEmail) {
                return form.namedInsuredEmail.value === form.secondEmail.value;
            }
        }
        return false;
    };

    const [promptToApplySignature, setPromptToApplySignature] = useState(true);

    const signatureTypeChange = (rsForm) => {
        if (requiredSignaturesForms.length > 1) {
            if (rsForm.signatureType.value && promptToApplySignature) {
                if (rsForm.signatureType.value.code !== 'signature_on_file') {
                    const componentProps = {
                        title: messages.applySignature,
                        uiProps: ApplySignatureTypeToAllPopupMetadata.pageContent,
                        actionBtnLabel: platformMessages.mlYes,
                        cancelBtnLabel: platformMessages.mlNo,
                        onSaveAction: () => {
                            requiredSignaturesForms.forEach((form) => {
                                form.signatureType.value = rsForm.signatureType.value;
                                if (isUserRetentionAgent && rsForm.signatureType.value.code !== 'esignature') {
                                    form.isSigned.value = true;
                                    form.signedDateTime.value = new Date();
                                }
                                updateWizardData(submissionVM);
                            });
                            return true;
                        }
                    };
                    modalApi.showModal(
                        <FormModalPopover {...componentProps} />
                    );
                }
                setPromptToApplySignature(false);
            }

            // when apply signature type to all list select no
            if (!rsForm.isSigned.value && ((isUserRetentionAgent && rsForm.signatureType.value.code !== 'esignature') || rsForm.signatureType.value.code === 'verbal')) {
                rsForm.isSigned.value = true;
                rsForm.signedDateTime.value = new Date();
            }
        }

        refreshData();
    };


    const clearActionFields = (form) => {
        if (!form.signatureType.value) {
            return;
        }
        if (form.signatureType.value.code !== 'fax') {
            _.set(form, 'faxNumber.value', _.get(submissionVM, 'baseData.primaryNamedInsured_ML.faxNumber.value'));
        }
        if (form.signatureType.value.code !== 'email' && form.signatureType.value.code !== 'esignature') {
            form.namedInsuredEmail.value = form.namedInsuredEmailDefault;
            if (shouldShowSecondEmail(form)) {
                form.secondEmail.value = form.secondEmailDefault;
            }
        }
        if (form.signatureType.value.code !== 'usps' && form.signatureType.value.code !== 'hard_copy' &&
            form.signatureType.value.code !== 'agent_esignature') {
            form.formLanguage.value = null;
        }
    };

    const shouldShowLanguageOption = (form) => {
        return false && form === null;
        // TODO: need new Spanish indicator in Form Pattern to support Language Option
        // return form.signatureType && form.signatureType.value && (form.signatureType.value.code === 'agent_esignature' || form.signatureType.value.code === 'hard_copy') && form.formNumber.value.indexOf('SP-') != -1;
    };

    const checkActionsCompleted = () => {
        return requiredSignaturesForms.every((form) => {
            if (!form.signatureType.value) {
                return false;
            }
            if (form.signatureType.value.code === 'fax' && !form.faxNumber.value) {
                return false;
            }
            if (form.signatureType.value.code === 'email' || form.signatureType.value.code === 'esignature') {
                if (checkIfEmailsAreDuplicated(form)) {
                    return false;
                }
            }
            if (shouldShowLanguageOption(form) && !form.formLanguage.value) {
                return false;
            }
            return true;
        });
    };

    const updateForms = () => {
        setRequiredSignaturesForms(getUncheckedAndESigFormsValues());
        setAvailableDocumentsForms(getAllVerbalAndESigForms());
    };

    const [blockedByUWIssues, setBlockedByUWIssues] = useState(false);

    const blockingUWIssuesPresentCallback = () => {
        submissionVM.blockNavigation_ML.value = true;
        setBlockedByUWIssues(true);
    };

    const approvedAllBlockingUWIssuesCallback = () => {
        submissionVM.blockNavigation_ML.value = false;
        setBlockedByUWIssues(false);
    };

    const viewDocument = (item) => {
        const errorCallback = () => {
            hideProgressDialog();
            showErrorModal(
                platformMessages.error,
                platformMessages.unableToDownloadDocument
            );
        };
        const downloadPromise = MLFormUtil.viewSubmissionForm(errorCallback, item.value, submissionVM, authHeader);
        showProgressDialog(platformMessages.downloadingDocument, downloadPromise);
        MLTagManagerService.sendLinkClickEvent('view_'.concat(item.value.formDescription));
    };

    const isDisclaimerActionCompleted = () => !_.isNull(oecRadioSelection)

    const isNextButtonDisabled = () => {
        switch (currentStep) {
            case steps.DISCLAIMER:{
                return !isDisclaimerActionCompleted()
            } 
            case steps.REQUIRED_SIGNATURES: {
                return !checkActionsCompleted();
            }
            case steps.AVAILABLE_DOCUMENTS: {
                //US993539
                return blockedByUWIssues || isFileUploadDone;
                //US993539;
            }
            default: {
                return false;
            }
        }
    };

    const getNextButtonLabel = () => {
        switch (currentStep) {
            case steps.VERBAL_AUTH:
            case steps.REQUIRED_SIGNATURES: {
                return platformMessages.mlContinue;
            }
            case steps.AVAILABLE_DOCUMENTS: {
                return isBundle ? platformMessages.mlContinue : messages.issuePolicy;
            }
            default: {
                return undefined;
            }
        }
    };

    const getNextDescription = () => {
        switch (currentStep) {
            case steps.VERBAL_AUTH: {
                return (
                    <FormattedMessage
                        {...messages.verbalAuthorizationNextDescription}
                        values={{
                            requiredForms: <strong>{translator(messages.requiredForms)}</strong>
                        }}
                    />
                );
            }
            case steps.REQUIRED_SIGNATURES: {
                return (
                    <FormattedMessage
                        {...messages.requiredSignatureNextDescription}
                        values={{
                            yourDocuments: <strong>{translator(messages.yourDocuments)}</strong>
                        }}
                    />
                );
            }
            case steps.AVAILABLE_DOCUMENTS: {
                return (isBundle ?
                    <FormattedMessage
                        {...messages.availableDocumentsBundledNextDescription}
                        values={{
                            bundleCart: <strong>{translator(messages.bundleCart)}</strong>
                        }}
                    /> :
                    <FormattedMessage
                        {...messages.availableDocumentsNonBundledNextDescription}
                        values={{
                            completeYourPurchase: <strong>{translator(messages.completeYourPurchase)}</strong>
                        }}
                    />
                );
            }
            default: {
                return undefined;
            }
        }
    };

    const bundleExecuteAndExit = () => {
        const promise = LoadSaveService.preBind(submissionVM.value, authHeader).then(() => {
            history.push(`/agent-bundle-cart/${submissionVM.value.baseData.accountNumber}`);
        });
        showProgressDialog(platformMessages.saveSubmission, promise);
    };

    const goToQuotePage = () => {
        const { steps, jumpTo } = wizardContext;
        const index = _.findIndex(steps, ({path}) => path === '/quote');
        submissionVM.value.forceRequote= true;
        jumpTo(index);
    }

    const showPaymentMismatchModal = () => {
        const componentProps = {
            simpleMessage: translator(messages.paymentMismatchError),
            actionBtnLabel: translator(messages.returnToQuote),
            showHeader: false,
            onCancelAction: goToQuotePage 
            
        };
        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const nextStep = () => {
        switch (currentStep) {
            case steps.VERBAL_AUTH: {
                initializeDisclaimerStep();
                break;
            }
            case steps.DISCLAIMER: {
                if(oecRadioSelection === true){
                    setScriptML([]);
                    setCurrentStep(steps.REQUIRED_SIGNATURES);
                }
                else{
                    goToQuotePage();
                }
                break;
            }
            case steps.REQUIRED_SIGNATURES: {
                setCurrentStep(steps.AVAILABLE_DOCUMENTS);
                MLMultiLobsDataHolderService.storeFlowSteps('requiredSignatures', 'availableDocuments', authHeader);
                break;
            }
            case steps.AVAILABLE_DOCUMENTS: {
                if (isBundle && MLBundleService.isJobPostQuoteComplete(submissionVM.quoteID.value)) {
                    MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(),
                        `${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}`);
                    bundleExecuteAndExit();
                } else {
                    const promise = LoadSaveService.bindSubmission(submissionVM.value, authHeader).then((res) => {
                        submissionVM.value = res;
                        goNext();
                    }).catch(error => {
                        //If Payment mismatch error received, go to Quote Page and force requote
                        if (error.baseError.includes(PAYMENT_MISMATCH_ERROR)) {
                            showPaymentMismatchModal(); 
                            
                            return false;
                        }

                        if (error.baseError.includes(PAYMENT_ERROR)) {
                            hideProgressDialog();
                            const errMsg = translator(messages.paymentError);
                            showErrorModal("Payment Error", errMsg);
                            return false;
                        }

                        if (isUMB_NP && error?.baseError?.indexOf("-31000-DISPLAYABLE_ERROR_ML") > -1) {
                            hideProgressDialog();
                            const errMsg = between(error.baseError, "Messages_ML: [", "] ").replace(':,', ':').replace('.,', '.');
                            showErrorModal("Bind Error", errMsg);    
                            return false;
                        }
                        
                        // US995072: Handle CDC Exceptions using Generic Error Handler
                        MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                    }).catch((error) => {
                        history.push('/contactUs', error);
                    });
                    showProgressDialog(messages.processingPayment, promise);
                }
                break;
            }
            default: {
                break;
            }
        }
    };
    const onNext = () => {
        setDisplayEmailWarning(false);
        //DE255327 field level error message's

        if(currentStep === steps.DISCLAIMER){
            nextStep();
            return;
        }

        setShowErrors(false);
        UserService.getCurrentUser(authHeader).then((user) => {
            if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                HOTrackEvent('Issuance Step Submitted', false, submissionVM, user, { step: 'Signature Page', action: 'Signature Submitted'});
            }
            else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                PUMBTrackEvent('Issuance Step Submitted', false, submissionVM, user, { step: 'Signature Page', action: 'Signature Submitted'});
            }
            else {
                PATrackEvent('Issuance Step Submitted', false, submissionVM, user, { step: 'Signature Page', action: 'Signature Submitted'});
            }
        });
        if (!isComponentValid || submissionVM.value.blockNavigation_ML) { 
            //DE255327 field level error message's
            setShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 100);
            return;
        }

        const updateFormPromise = MLFormService.updateForms(submissionVM.quoteID.value, submissionVM.bindData.forms_ML.value, authHeader);
        showProgressDialog(messages.updatingForms, updateFormPromise);

        updateFormPromise.then(() => {
            if (currentStep === steps.AVAILABLE_DOCUMENTS && isBundle) {
                MLBundleService.setJobPostQuoteComplete(submissionVM.quoteID.value, authHeader);
            }
            // deferred.resolve();
            nextStep();
        }, (error) => {
            console.error(error);
            // deferred.resolve();
            // flowModel.jumpToExit('error', submissionVM);
        });

        updateForms();
    };

    const handleOnBlur = ( rsForm, event ) => {
        let emailAddress1 =  event.target.value;
        if(emailAddress1){
            emailAddress1=emailAddress1.trim();
        }
        let isValidEmailEntred =  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
        if(isValidEmailEntred){
            const checkEmailVerified_Ext = AccountService.checkEmailVerified_Ext(
                emailAddress1,
                authHeader
            );
            showProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
            checkEmailVerified_Ext.then((res) => {
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log("Email verification Api Called");
                if(res === true){
                    let email = rsForm.value;
                    if(email !== "" && email !== undefined){
                        email = email.trim();
                        rsForm.value = email;
                    }
                }
                else{
                    let email = rsForm.value;
                    if(email !== "" && email !== undefined){
                        email = email + " ";
                        rsForm.value = email;
                    }
                }
            }).catch((e) => {
                clearBlockAlerts('invalidEmail');
                setDisplayEmailWarning(true);
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                rsForm.value = emailAddress1;
                console.log(e);
                window.scrollTo(0, 0);
            });
        }
    }

    const getContingenciesTableData = () => _.get(submissionVM,'openOrClosedPreBindContingencies.value', [])

    const generateOverrides = () => {
        const openContingenciesOverride = getContingenciesTableData().map((openContingency, index) => ({
                [`contingencyTitle${index}`]: {
                    content: (<div>
                        <li>{openContingency.title} &nbsp;
                        {openContingency.description_ML && <TooltipIcon
                            text={openContingency.description_ML}
                            />}
                        </li>
                    </div>)
                },
                [`contingencyAction${index}`]: {
                    content: (<div>
                        <li>{openContingency.docRetentionStatus}
                        </li>
                    </div>)
                }              
            }));


        return Object.assign({}, ...openContingenciesOverride);
    };


    const overrideProps = {
        warningInlineNotification: {
            visible: displayEmailWarning,
        },
        gpaPageHeader: {
            content: translator(getPageHeader())
        },
        verbalAuthorizationComponent: {
            visible: currentStep === steps.VERBAL_AUTH,
            verbalAuthForms,
            convertDateToUTC
        },
        requiredSignaturesComponent: {
            visible: currentStep === steps.REQUIRED_SIGNATURES,
            requiredSignaturesForms : (organization?.name?.toLowerCase().includes(mercerOrganization) &&  gafInfo?.gpcCode === mercerGpcCode) ?
            requiredSignaturesForms.filter((rsForm)=> rsForm.publicID.value !== appConfig.payrollAuthorizationPublicId ||
            gafInfo?.payrollAuthorizationFormIndicator === 'Required') :
            requiredSignaturesForms,
            isSignatureOnFileAvailable,
            appSignatureTypeList,
            signatureTypeList,
            shouldShowLanguageOption,
            clearActionFields,
            signatureTypeChange,
            checkIfEmailsAreDuplicated,
            shouldShowSecondEmail,
            shouldShowSecondMobile,
            shouldShowAdditionalInsuredEmail,
            updateSecondaryInsuredEmail: (value) => {
                submissionVM.baseData.secondaryNamedInsured_ML.emailAddress1.value = value;
            },
            updateAdditionalInsuredEmail: (value) => {
                submissionVM.baseData.secondaryNamedInsured_ML.emailAddress1.value = value;
            },
            onValidate,
            handleOnBlur,
            showValidationErrors,
            submissionVM,
            isHomeOwner:submissionVM?.baseData?.productCode?.value === 'HOPHomeowners',
            isPersonalUmbrella:submissionVM?.baseData?.productCode?.value==='PersonalUmbrella'
        },
        availableDocumentsComponent: {
            visible: currentStep === steps.AVAILABLE_DOCUMENTS,
            availableDocumentsForms,
            isUserRetentionAgent,
            convertDateToUTC,
            viewDocument,
            scriptML,
            uwIssues,
            quoteID,
            blockingUWIssuesPresentCallback,
            approvedAllBlockingUWIssuesCallback,
            submissionVM,
            setIsFileUploadDone,
            updateWizardData
        },
        remindersRow:{
            visible: currentStep === steps.AVAILABLE_DOCUMENTS && !_.isEmpty(_.get(submissionVM,'openOrClosedPreBindContingencies.value',[])),
        },
        openPreBindContingenciesIterable: {
            data: getContingenciesTableData()
        },
        disclaimersComponent:{
            visible: currentStep === steps.DISCLAIMER && !_.isEmpty(scriptML),
            setRadioSelection: setoecRadioSelection,
            radioSelection: oecRadioSelection,
            scriptML
        },
        nextButton: {
            disabled: isNextButtonDisabled(),
            content: translator(getNextButtonLabel())
        },
        nextDescription: {
            content: getNextDescription()
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onNext
        },
        resolveComponentMap: {
            verbalAuthorizationComponent: VerbalAuthorizationComponent,
            requiredSignaturesComponent: RequiredSignaturesComponent,
            availableDocumentsComponent: AvailableDocumentsComponent,
            disclaimerComponent : DisclaimerComponent
        },
        resolveClassNameMap: styles
    };

    return (
        <WizardPage
            showPrevious={false}
            showCancel={false}
            showNext={false}
        >
            {currentStep && <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                onValidationChange={onValidate}
                showErrors={showValidationErrors}
            />}
        </WizardPage>
    );
};

AgentSignatureOptionsPage.propTypes = wizardProps;
export default withRouter(AgentSignatureOptionsPage);
